export enum DEFAULT_COLS_KEY {
  USERNAME = 'username',
  DATE_TIME = 'dateTime',
  PATIENT_NAME = 'patientName',
  ID = 'id',
  DOB = 'dob',
  ATTEMPTS = 'attempts',
}
